export enum SegmentEditorItemType {
    TranslationSegment = 1,
    MergeSegment,
    SplitSegment,
}